import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { BvTableFieldArray } from 'bootstrap-vue';
import { PersonaMoral, SubsedeMoral } from '@/shared/model/persona/persona-moral.model';

@Component
export default class BuscadorPersonasMoralesComponent extends Vue {
  @Prop({ required: true })
  public institucion: PersonaMoral;

  @Prop({ required: false, default: false })
  public seleccionarSoloSede: boolean;

  @Prop({ required: false, default: false })
  public generarSedeComoSubsede: boolean;

  public currentPagePersonas = 1;
  public currentPage = 1;
  public totalRows = 0;
  public perPage = 15;

  public readonly pageOptions: Array<number> = [5, 15, 25, 50, 100, 150];
  public readonly fieldsSubsedes: BvTableFieldArray = [
    {
      key: 'nombreSede',
      label: this.$t('apeironGwApp.buscadorPersonasMorales.card.nombreSubsede').toString(),
      class: 'text-left',
      thStyle: { width: '35rem' },
    },
    {
      key: 'noDeRegistro',
      label: this.$t('apeironGwApp.buscadorPersonasMorales.card.noDeRegistro').toString(),
      class: 'text-left',
      thStyle: { width: '30rem' },
    },
    {
      key: 'entidadFederativa',
      label: this.$t('apeironGwApp.buscadorPersonasMorales.card.entidadFederativa').toString(),
      class: 'text-left',
      thStyle: { width: '35rem' },
    },
    {
      key: 'municipio',
      label: this.$t('apeironGwApp.buscadorPersonasMorales.card.municipio').toString(),
      class: 'text-left',
      thStyle: { width: '35rem' },
    },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.buscadorPersonasMorales.card.acciones').toString(),
      class: 'text-center btn-acciones',
      thStyle: { width: '7rem' },
    },
  ];

  public seleccionarConSubsede(subsedeMoral: SubsedeMoral): void {
    this.emitirSeleccion(subsedeMoral);
  }

  public seleccionarSinSubsede(): void {
    this.emitirSeleccion(undefined);
  }

  @Emit('selected')
  public emitirSeleccion(subsedeMoral: SubsedeMoral): PersonaMoral {
    const personaMoralSeleccionada = { ...this.institucion };

    if (subsedeMoral) {
      personaMoralSeleccionada.subsdes = [{ ...subsedeMoral }];
    } else {
      personaMoralSeleccionada.subsdes = [];
    }

    return personaMoralSeleccionada;
  }
}
